export class TasaRedescuentoBancoldex {
  constructor(
    public codigoBaseTasaRed: Number,
    public baseTasaRed: String,
    public puntosAdicionales: Number
  ) {}
}
